import { ListTag, NocFlagSvg, hasNocFlag } from "@seagames/ui";

const BOX = {
	xs: "h-[0.625rem] w-[0.9375rem] rounded-[0.125rem]",
	sm: "h-[0.75rem] w-[1.125rem] rounded-[0.125rem]",
	md: "h-[1rem] w-[1.5rem] rounded-[0.1875rem]",
	lg: "h-[1.75rem] w-[2.625rem] rounded-[0.3125rem]",
} as const;

/**
 * An NOC's flag, drawn in the app (`@seagames/ui` `noc-flags.tsx`, shared
 * with OVR) — never fetched, so it draws offline and never asks a CDN. Keyed
 * by the organisation's country code (IOC); a code with no drawing gets a
 * neutral swatch. Decorative: the code or name beside it is the text.
 */
export function NocFlag({ code, size = "sm", className = "" }: { code: string | null | undefined; size?: keyof typeof BOX; className?: string }) {
	const box = `${BOX[size]} inline-flex shrink-0 overflow-hidden shadow-[0_0_0_1px_rgba(18,20,63,0.12)] ${className}`;
	if (hasNocFlag(code))
		return (
			<span aria-hidden="true" className={box}>
				<NocFlagSvg code={code} className="size-full" />
			</span>
		);
	return <span aria-hidden="true" className={`${box} bg-gms-soft-2`} />;
}

/**
 * An organisation's code as a tag with its flag in front (user, 2026-11-03:
 * every NOC shown gets its flag). No code (the host, a broadcaster) = the
 * name, no flag. The name is the tooltip.
 */
export function OrgFlagTag({ code, name, title }: { code: string | null | undefined; name: string; title?: string }) {
	return (
		<span className="inline-flex max-w-full min-w-0 items-center gap-[0.3125rem]">
			{code && <NocFlag code={code} size="xs" />}
			<ListTag title={title ?? name}>{code ?? name}</ListTag>
		</span>
	);
}
